import { render, staticRenderFns } from "./OnboardingElectronicAddressPage.vue?vue&type=template&id=a3d45034&scoped=true&"
import script from "./OnboardingElectronicAddressPage.vue?vue&type=script&lang=js&"
export * from "./OnboardingElectronicAddressPage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingElectronicAddressPage.vue?vue&type=style&index=0&id=a3d45034&prod&lang=scss&"
import style1 from "./OnboardingElectronicAddressPage.vue?vue&type=style&index=1&id=a3d45034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d45034",
  null
  
)

export default component.exports